module.exports = __webpack_public_path__ + "static/media/arrow-is-wrong.eeab22f8.mp3";